export const GUESTBOOK_CONTRACT_ID = "guest-book.testnet";
